import React, { useEffect, useState } from 'react';
import { DataTable, emptyDataTable } from '../../../../../core/components/Table/types/DataTable';
import { useParams } from 'react-router-dom';
import ApiProvider from '../../../../../core/api/ApiProvider';
import { ResponseApiType } from '../../../../types/ResponseApiType';
import { InfoMessageService, TranslationService } from '../../../../../core/services';
import { Loader, Table } from '../../../../../core/components';

const Invoices = () => {
  const { caseNumber } = useParams() as { caseNumber: string };
  const [table, setTable] = useState<DataTable>({ ...emptyDataTable });
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchInvoices = async () => {
    try {
      const result = await ApiProvider.get<ResponseApiType<{ table: DataTable }>>(
        `InvoicesModule/GetInvoices/${caseNumber}`
      );

      if (result.success) {
        const rows = result.data.table.dataRows.map((h: any, index: number) => ({
          ...h,
          id: `${h.ColumnName}${index}`,
        }));

        let headers = result.data.table.headers.map((h) => {
          let cssClassNames = '';

          if (h.columnName === 'InterestBalance') {
            cssClassNames = 'to-right';
          }

          if (h.columnName === 'Balance') {
            cssClassNames = 'to-right';
          }

          if (h.columnName === 'AmountOnInvoice') {
            cssClassNames = 'to-right';
          }

          return {
            ...h,
            cssClassNames: `${cssClassNames} ${!h.isVisible && 'hide-d'} ${
              !h.isVisibleOnMobile && 'hide-m'
            }`,
          };
        });

        headers.push({
          columnName: 'Id',
          headerName: '',
          isVisible: false,
          cssClassNames: '',
        });

        setTable({
          headers: headers,
          dataRows: rows,
        });
      } else {
        throw result.message;
      }
    } catch (err) {
      InfoMessageService.error(
        (err as string) || TranslationService.translate('ErrorSthWentWrong')
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {table.headers.length > 0 && (
            <Table
              headers={table.headers}
              rows={table.dataRows}
              keyField="id"
              paginationProps={{
                hideSizePerPage: true,
                hidePageListOnlyOnePage: true,
              }}
            />
          )}
        </>
      )}
    </>
  );
};

export default React.memo(Invoices);
